




































import { Component, Prop, Vue, Ref } from "vue-property-decorator";
import {
  ProductInstanceResult,
  INSTANCE_STATION,
  INSTANCE_COMPANY,
  INSTANCE_CLUSTER
} from "@futuri/cloudsso-client/src/client/types/productInstances";
import { Action, Getter } from "vuex-class";
import {
  matchInstancesByPrefix,
  getInstanceCluster
} from "@futuri/cloudsso-client/src/instanceUtils";

@Component
export default class BoundInstances extends Vue {
  // @Getter('cachedInstances', { namespace: 'adminUserPost' })
  // cachedInstances?: CachedInstances

  // get instances() { return this.cachedInstances?.instances }

  // @Prop()
  // instances?: ProductInstanceResult[]

  @Ref("searchBar")
  searchBar!: any;

  @Ref("table")
  table!: any;

  // @Getter('availableInstances')
  // instances?: ProductInstanceResult[]

  @Prop()
  instances?: ProductInstanceResult[];

  stationSearchPrefix = "";

  @Getter("currentCompany", { namespace: "adminUserPost" })
  currentCompany?: string;

  @Action("setSelectedBinding", { namespace: "adminUserPost" })
  setSelectedBinding!: (instanceId?: string) => Promise<void>;

  @Prop()
  filter?: (instance: ProductInstanceResult) => boolean;

  get displayCompany() {
    return this.companyInstance?.name ?? "";
  }

  get companyInstance(): ProductInstanceResult | undefined {
    console.log("get companyInstance");
    const instances = this.instances;
    if (!instances?.length) {
      return undefined;
    }

    const companyInstance = instances.filter(
      inst => inst.instanceType === INSTANCE_COMPANY
    )[0];
    return companyInstance;
  }

  get clusterInstances(): ProductInstanceResult[] {
    console.log("get clusterInstances");
    const instances = this.instances;
    if (!instances?.length) {
      return [];
    }

    const clusterInstances = instances.filter(
      inst => inst.instanceType === INSTANCE_CLUSTER
    );
    return clusterInstances;
  }

  handleEditCompany() {
    const companyInstance = this.companyInstance;
    this.setSelectedBinding(companyInstance?.instanceId);
  }

  handleEditCluster(event: MouseEvent) {
    const instanceId = (event.srcElement as HTMLElement)?.dataset?.cluster;
    if (instanceId?.length) {
      this.setSelectedBinding(instanceId);
    }
  }

  get stationInstances(): ProductInstanceResult[] | undefined {
    console.log("get stationInstances");
    const instances = this.instances;
    if (!instances?.length) {
      return undefined;
    }

    const stationInstances = instances?.filter(
      inst => inst.instanceType === INSTANCE_STATION
    );
    return stationInstances;
  }

  get headers() {
    const headers = [
      { label: "✎" },
      { label: "☑" },
      { label: "State" },
      { label: "Region" },
      { label: "City" },
      { label: "Cluster" },
      { label: "Format" },
      { label: "Station" }
    ];

    return headers;
  }

  get items() {
    // if (this.stationSearchPrefix?.length) {
    //   return [{ "Station": this.stationSearchPrefix }]
    // }
    // return []

    console.log("getting bound instances");

    const createCheckbox = (): HTMLInputElement => {
      const el = document.createElement("input");
      el.setAttribute("type", "checkbox");
      el.setAttribute("checked", "checked");
      return el;
    };

    const editBinding = (instanceId: string): void => {
      this.setSelectedBinding(instanceId);
    };

    const editLink = (instanceId: string): HTMLAnchorElement => {
      const el = document.createElement("a");
      el.textContent = "✎";
      el.setAttribute("href", "#");
      el.setAttribute("style", "text-decoration: none;");
      el.onclick = (e: MouseEvent) => {
        editBinding(instanceId);
        e.preventDefault();
      };
      return el;
    };

    const label = (text: string, style: string): HTMLElement => {
      const div = document.createElement("span");
      // div.setAttribute("style", "display: inline-block;")
      div.setAttribute("style", "box-sizing: border-box;");
      const el = document.createElement("span");
      el.setAttribute("style", style);
      el.textContent = text;
      div.appendChild(el);
      return div;
    };

    const companyLabel = (text: string): HTMLElement => {
      return label(text, "font-weight: 800;");
    };

    const clusterLabel = (text: string): HTMLElement => {
      const style =
        "font-weight: 600; display: inline-block; margin-left: 20px;";
      return label(text, style);
    };

    const stationLabel = (text: string): HTMLElement => {
      const style = "display: inline-block; margin-left: 40px;";
      return label(text, style);
    };

    // const stations = this.instances?.filter(inst => !inst.instanceType || inst.instanceType === INSTANCE_STATION)
    // const stations = this.stationInstances
    const instances = this.instances ?? [];

    const alwaysTrue = (_: ProductInstanceResult) => true;
    const filter = this.filter ?? alwaysTrue;
    const boundInstances = instances.filter(filter);

    const stationSearchPrefix = this.stationSearchPrefix ?? "";
    const matching = matchInstancesByPrefix(
      boundInstances,
      stationSearchPrefix
    );

    const toTableRow = (inst: ProductInstanceResult) => {
      const { instanceId, instanceType, name, criteria } = inst;
      const state = criteria?.filter(c => c.key === "state")[0]?.value ?? "-";
      const region = criteria?.filter(c => c.key === "region")[0]?.value ?? "-";
      const format = criteria?.filter(c => c.key === "format")[0]?.value ?? "-";
      const cluster = getInstanceCluster(inst);

      if (instanceType === INSTANCE_COMPANY) {
        const companyRow = {
          "✎": editLink(instanceId),
          "☑": createCheckbox(),
          State: {
            cell: companyLabel(inst?.name),
            colspan: 6
          }
        };
        return companyRow;
      } else if (instanceType === INSTANCE_CLUSTER) {
        const clusterRow = {
          "✎": editLink(instanceId),
          "☑": createCheckbox(),
          State: {
            cell: clusterLabel(inst?.name),
            colspan: 6
          }
        };
        return clusterRow;
      }

      const orDefault = (s?: string): string => (s?.length ? s : "-");

      const stationRow = {
        "✎": editLink(instanceId),
        "☑": createCheckbox(),

        State: stationLabel(orDefault(state)),
        Region: orDefault(region),
        City: "-",
        Cluster: orDefault(cluster),
        Format: orDefault(format),
        Station: orDefault(name)
      };

      return stationRow;
    };

    // const items = matching?.map(inst => {
    //   const { instanceId, name, criteria } = inst;
    //   const state = criteria.filter(c => c.key === "state")[0]?.value ?? '-'
    //   const region = criteria.filter(c => c.key === "region")[0]?.value ?? '-'
    //   const format = criteria.filter(c => c.key === "format")[0]?.value ?? '-'

    //   const cluster = (this.currentCompany === 'iHeartMedia' && region !== '-') ?
    //     `IHM ${region}` : 'IHM (Unknown)'

    //   return {
    //     '✎': editLink(instanceId),
    //     "☑": createCheckbox(),

    //     State: state,
    //     Region: region,
    //     City: "-",
    //     Cluster: cluster,
    //     Format: format,
    //     Station: name
    //   };
    // });

    const items = matching.map(toTableRow);

    return items;
  }

  // Replace when we update uikit
  connectSearch() {
    this.$nextTick(() => {
      const searchBar = this.$refs.searchBar as any;
      const cards = this.$refs.cards as any;

      if (searchBar) {
        searchBar.onSearch = (query: string) => {
          console.log("query: ", query);

          cards.submitSearch(query);
        };

        // cards.productType = view.productType

        const inputEl = searchBar?.shadowRoot?.querySelector("input");
        let prev = "";

        const view = this as BoundInstances;
        const table = this.table;
        inputEl?.addEventListener("keyup", (e: KeyboardEvent) => {
          const val = inputEl.value;
          if (val !== prev) {
            console.log("fayt: ", val);
            Vue.set(view, "stationSearchPrefix", val);
            // view.stationSearchPrefix = val

            // table.data = view.items
          }
          prev = val;
        });
      }
    });
  }

  mounted() {
    this.connectSearch();
  }
}
